import { render, staticRenderFns } from "./ta-slider3.vue?vue&type=template&id=04456529&scoped=true&"
import script from "./ta-slider3.vue?vue&type=script&lang=js&"
export * from "./ta-slider3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04456529",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VIcon,VSlider})
